import { lazy } from "react";

const EmailLinkExpired = lazy(() => import('./email-link-expired'));
const LoginErrorModel = lazy(() => import('./login-error-modal'));
const LovedBy = lazy(() => import('./loved-by'));
const ExpiredInvitation = lazy(() => import('./expired-invitation'));
const SignupForm = lazy(() => import('./signup-form'));

export {
  EmailLinkExpired,
  LoginErrorModel,
  LovedBy,
  ExpiredInvitation,
  SignupForm,
};
